import { common } from '@mui/material/colors';
import { alpha } from '@mui/material/styles';

import { error, info, neutral, petrol, success, warning, yellow } from '../colors';

/**
 * @returns {import('@mui/material/styles').PaletteOptions & {neutral: { [key: string]: string}}} Palette options
 */
export const createPalette = () => {
  return {
    action: {
      active: neutral[500],
      disabled: alpha(neutral[900], 0.38),
      disabledBackground: alpha(neutral[900], 0.12),
      focus: alpha(neutral[900], 0.16),
      hover: alpha(neutral[900], 0.04),
      selected: alpha(neutral[900], 0.12),
    },
    background: {
      default: common.white,
      paper: common.white,
    },
    divider: neutral[200], // gray4
    error,
    info,
    mode: 'light',
    neutral,
    primary: yellow,
    secondary: petrol,
    success,
    text: {
      primary: neutral[900],
      secondary: neutral[500],
      disabled: alpha(neutral[900], 0.38),
    },
    warning,
  };
};
